// src/services/api.js
import axios from 'axios';
import store from '@/store'; // Vuex store
import router from '@/router'; // Router

const apiClient = axios.create({
  // Backend API adresiniz (.env'den alınabilir veya doğrudan yazılabilir)
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:5001/api',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

// Request Interceptor (İstek gönderilmeden önce araya girer)
apiClient.interceptors.request.use(
  config => {
    const token = store.getters['auth/isAuthenticated'] ? store.state.auth.token : null;
    if (token) {
      // Her isteğe Authorization başlığını ekle (Bearer token formatında)
      config.headers['Authorization'] = `${token}`; // Backend'in 'Bearer ' kısmını beklemediğini varsayalım, bekliyorsa ekleyin
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response Interceptor (Yanıt alındıktan sonra araya girer)
apiClient.interceptors.response.use(
  response => {
    // Başarılı yanıtları doğrudan döndür
    return response;
  },
  error => {
    // Hata durumlarını işle
    if (error.response) {
      const status = error.response.status;
      // Örneğin 401 Unauthorized hatası (token geçersiz veya yok)
      if (status === 401 && router.currentRoute.value.name !== 'Login') {
          console.warn('Unauthorized request or invalid token. Logging out...');
          // Otomatik logout yap ve Login sayfasına yönlendir
          store.dispatch('auth/logout');
      }
      // Diğer hatalar (403 Forbidden, 404 Not Found vb.) component içinde ele alınabilir
    } else if (error.request) {
      // İstek yapıldı ama yanıt alınamadı (network hatası vb.)
      console.error('Network Error:', error.message);
      store.commit('SET_ERROR', 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.', { root: true });
    } else {
      // İsteği ayarlarken bir hata oluştu
      console.error('Error setting up request:', error.message);
    }
    // Hatanın component/action tarafından yakalanabilmesi için reject et
    return Promise.reject(error);
  }
);


export default apiClient;